import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  IsBoolean,
  IsDate,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
} from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

import { EUserBanSource } from './security.enums';

@Index(['userId'], { unique: true })
export class UserBan extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  @Index()
  @Column({ type: 'boolean', nullable: false, default: false })
  isActive: boolean;

  @ApiProperty()
  @IsBoolean({ groups: ['error'] })
  @Column({ type: 'boolean', nullable: false, default: false })
  isPermanent: boolean;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  banUntil?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'text', nullable: true })
  reason?: string | null;

  @ApiProperty()
  @IsEnum(EUserBanSource, { groups: ['error'] })
  @Column({ type: 'varchar', enum: EUserBanSource, nullable: false })
  source: EUserBanSource;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  actorLabel?: string | null;

  @ApiProperty()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: false, precision: 3 })
  activatedAt: Date;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  liftedAt?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  @Index()
  @Column({ type: 'int', nullable: true })
  linkedBanOriginUserId?: number | null;
}
